/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Links } from './Links';
import {
    LinksFromJSON,
    LinksFromJSONTyped,
    LinksToJSON,
} from './Links';
import type { TransactionsTransactionIn } from './TransactionsTransactionIn';
import {
    TransactionsTransactionInFromJSON,
    TransactionsTransactionInFromJSONTyped,
    TransactionsTransactionInToJSON,
} from './TransactionsTransactionIn';

/**
 * 
 * @export
 * @interface GetMoneyInIBANDetailsOutput
 */
export interface GetMoneyInIBANDetailsOutput {
    /**
     * 
     * @type {TransactionsTransactionIn}
     * @memberof GetMoneyInIBANDetailsOutput
     */
    transactions?: TransactionsTransactionIn;
    /**
     * 
     * @type {Links}
     * @memberof GetMoneyInIBANDetailsOutput
     */
    links?: Links;
    /**
     * 
     * @type {Error}
     * @memberof GetMoneyInIBANDetailsOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the GetMoneyInIBANDetailsOutput interface.
 */
export function instanceOfGetMoneyInIBANDetailsOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetMoneyInIBANDetailsOutputFromJSON(json: any): GetMoneyInIBANDetailsOutput {
    return GetMoneyInIBANDetailsOutputFromJSONTyped(json, false);
}

export function GetMoneyInIBANDetailsOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMoneyInIBANDetailsOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactions': !exists(json, 'transactions') ? undefined : TransactionsTransactionInFromJSON(json['transactions']),
        'links': !exists(json, '_links') ? undefined : LinksFromJSON(json['_links']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function GetMoneyInIBANDetailsOutputToJSON(value?: GetMoneyInIBANDetailsOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactions': TransactionsTransactionInToJSON(value.transactions),
        '_links': LinksToJSON(value.links),
        'error': value.error,
    };
}

